import type { ApiResult } from '@/infra/api'
import { API_ENDPOINTS, httpGet } from '@/infra/api'
import type { HostProjectsResponse } from './types'

export const hostProjectsClient = {
  fetchHostProjects(hostId: string): Promise<ApiResult<HostProjectsResponse>> {
    return httpGet<HostProjectsResponse>(`${API_ENDPOINTS.HOST_PROJECTS}/${hostId}`)
  },
}
